import React from "react";
import { observer } from "mobx-react";
import type { IResourcesStore } from "../../resources/ResourcesStore";
import { injectFromAppLegal } from "../inject";
import type { ICookieSettingsStore } from "../../shared-components/cookie-banner/CookieSettingsStore";
import { CookiePolicyIT } from "./CookiePolicyIT";
import { CookiePolicyDE } from "./CookiePolicyDE";
import { CookiePolicyES } from "./CookiePolicyES";
import { CookiePolicyFR } from "./CookiePolicyFR";
import { CookiePolicyNL } from "./CookiePolicyNL";
import { CookiePolicyPTBR } from "./CookiePolicyPTBR";
import { CookiePolicyEN } from "./CookiePolicyEN";
import { CookiePolicyNO } from "./CookiePolicyNO";
import { DobButton } from "@dedalusdiit/dob-components";
import { LegalPartialContainerComponent } from "../LegalPartialContainerComponent";

interface ICookiePolicyComponentProps {
    resourcesStore?: IResourcesStore;
    cookieSettingsStore?: ICookieSettingsStore;
}

@injectFromAppLegal<ICookiePolicyComponentProps>(stores => ({
    resourcesStore: stores.resourcesStore,
    cookieSettingsStore: stores.cookieSettingsStore,
}))
@observer
export class CookiePolicyComponent extends React.Component<ICookiePolicyComponentProps> {
    showCookieBanner = (event): void => {
        const { cookieSettingsStore } = this.props;
        cookieSettingsStore!.show();
    };

    render() {
        const { resourcesStore } = this.props;
        const { currentLanguage, resources } = resourcesStore!;

        let translatedCookiePolicy;

        switch (currentLanguage) {
            case "nl":
                translatedCookiePolicy = <CookiePolicyNL />;
                break;
            case "fr":
                translatedCookiePolicy = <CookiePolicyFR />;
                break;
            case "de":
                translatedCookiePolicy = <CookiePolicyDE />;
                break;
            case "pt-br":
                translatedCookiePolicy = <CookiePolicyPTBR />;
                break;
            case "es":
                translatedCookiePolicy = <CookiePolicyES />;
                break;
            case "it":
                translatedCookiePolicy = <CookiePolicyIT />;
                break;
            case "no":
                translatedCookiePolicy = <CookiePolicyNO />;
                break;
            case "en":
            default:
                translatedCookiePolicy = <CookiePolicyEN />;
                break;
        }

        return (
            <LegalPartialContainerComponent title={resources.CookiePolicy}>
                <DobButton color={"secondary"} onClick={this.showCookieBanner}>
                    {resources.ChangeCookieSettings}
                </DobButton>
                <br />
                <br />
                {translatedCookiePolicy}
            </LegalPartialContainerComponent>
        );
    }
}
